/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader404,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader500,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader } from "../../clients/individualPaymentParcelsController/getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryKey =
  (
    financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderPathParams["financialPersonId"],
    params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryParams,
  ) =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/header",
        params: { financialPersonId: financialPersonId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryKey
  >;

export function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryOptions(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryKey(
      financialPersonId,
      params,
    );
  return queryOptions<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader404
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader500
    >,
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponse,
    typeof queryKey
  >({
    enabled: !!financialPersonId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader(
        financialPersonId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna dados do aluno/terceiro, curso, totais (transferências, matrícula, pago), valor líquido com descontos (cupom, empresa, pontualidade, indicação), valor com bolsa, cartão mascarado, descontos ativos e validações de consistência. Os enums do plano vêm com o texto traduzido na cultura da requisição: 'typeText' (tipo), 'statusText' (status) e 'paymentTypeText' (método de pagamento). 404 quando o plano não existe ou a empresa do usuário difere da matrícula. Migrado do legado IndividualPayment/Parcels (GetParcelsGridDetail). **(Requer Authorization para autenticação)**
 * @summary Retorna o cabeçalho da tela de parcelas do plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/header}
 */
export function useGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader<
  TData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryKey,
>(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader401
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader404
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryKey(
      financialPersonId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryOptions(
        financialPersonId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader404
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
